import Link from 'next/link';
import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { IEditorialCard } from '../types';

const maxCardDimension = 325;

const Card: React.FC<IEditorialCard> = ({
  title,
  image,
  alt,
  url,
  bgColor,
}) => {
  return (
    <>
      <article className="card" style={{ maxWidth: maxCardDimension }}>
        <Link href={url} legacyBehavior>
          <a data-testid={`Card-go-to-${url}`} title={title}>
            <div className="shape" />
            {title && (
              <span className="title" title={title}>
                {title}
              </span>
            )}
            {image ? (
              <div className="img">
                <ResponsiveImage
                  src={image}
                  alt={alt}
                  width={maxCardDimension}
                  height={maxCardDimension}
                  objectFit="cover"
                />
              </div>
            ) : null}
          </a>
        </Link>
      </article>
      <style jsx>{`
        .card {
          overflow: hidden;
          position: relative;
          border-radius: var(--rd-4);
          height: 163px;
          min-width: 140px;

          /* hide the picture overflow */
          /* border: 1px solid var(--white);*/
          box-shadow: inset 0 0 0 0.3px var(--white);
        }

        a {
          display: block;
          height: 100%;
        }

        .shape {
          shape-outside: polygon(0% 0, 100% 0%, 100% 100%);
          clip-path: polygon(100% 0%, 0% 100%, 0% 0%);
          width: 350%;
          height: 50%;
          background-color: ${bgColor || 'var(--clr-primary-1)'};
          position: absolute;
          top: -1px;
          left: -1px;
        }

        .title {
          font-size: var(--font-size-2);
          top: var(--space-4);
          left: var(--space-4);
          right: var(--space-2);
          color: ${!bgColor ? `var(--white)` : `var(--black)`};
          position: absolute;
          font-weight: var(--font-weight-base);
          line-height: 22px;
        }

        .img {
          right: 0;
          bottom: 0;
          position: absolute;
          height: 100%;
          width: 100%;
          z-index: -1;
        }

        .img > :global(span) {
          height: 100%;
          width: 100%;
        }
      `}</style>
    </>
  );
};

export default Card;
